import { render } from "./Stepper.vue?vue&type=template&id=2d463aa4&scoped=true"
import script from "./Stepper.vue?vue&type=script&lang=js"
export * from "./Stepper.vue?vue&type=script&lang=js"

import "./Stepper.vue?vue&type=style&index=0&id=2d463aa4&lang=css"
import "./Stepper.vue?vue&type=style&index=1&id=2d463aa4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2d463aa4"

export default script